import React from 'react';
import PropTypes from 'prop-types';
import Gravatar from 'react-gravatar';
import CommunityAuthor from './CommunityAuthor';
import styles from './styles.module.styl';

const CompanyIcon = () => (
  <img
    className={styles.auth0Logo}
    src="https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.svg"
    alt=""
  />
);

const PlatformInformation = ({
  author,
  sdk,
  releasesUrl,
  githubData
}) => {
  if (author.community) {
    const { org, repo } = githubData;
    return <CommunityAuthor org={org} repo={repo} />;
  }

  return (
    <div className={styles.author}>
      <Gravatar email={author.email} default="mm" className={styles.avatar} />
      <div>
        <h5 className={styles.authorName}>
          By {author.name} {<CompanyIcon />}
        </h5>
        <div>
          {sdk && <a href={sdk.url}>{sdk.name}</a>}
          {sdk && releasesUrl && <span className={styles.seperator}> | </span>}
          {releasesUrl && <a href={releasesUrl}>See older releases</a>}
        </div>
      </div>
    </div>
  );
};

PlatformInformation.defaultProps = {
  author: {
    community: false
  },
  githubData: {
  }
};

PlatformInformation.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    community: PropTypes.bool.isRequired
  }),
  sdk: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  }),
  githubData: PropTypes.shape({
    org: PropTypes.string,
    repo: PropTypes.string
  }),
  releasesUrl: PropTypes.string
};

export default PlatformInformation;
